"use client";

import { motion } from "motion/react";

import { EASE_OUT_EXPO } from "@/components/motion/reveal";

import { useReveal } from "../../../_lib/use-reveal";

// =============================================================================

export type StackItem = {
  key: string;
  name: string;
  /** SkillIcon, rendered on the server */
  icon: React.ReactNode;
};

/**
 * Logos of the stack popping in one after another; the name shows on hover.
 */
export function StackIcons({ items }: { items: StackItem[] }) {
  const { ref, isRevealed } = useReveal<HTMLUListElement>();

  return (
    <motion.ul
      ref={ref}
      initial="hidden"
      animate={isRevealed ? "visible" : "hidden"}
      transition={{ staggerChildren: 0.05, delayChildren: 0.35 }}
      className="flex flex-wrap gap-2"
    >
      {items.map((item) => (
        <motion.li
          key={item.key}
          variants={{
            hidden: { opacity: 0, scale: 0.6, y: 10 },
            visible: {
              opacity: 1,
              scale: 1,
              y: 0,
              transition: { duration: 0.7, ease: EASE_OUT_EXPO },
            },
          }}
          className="group/icon relative"
        >
          <span
            title={item.name}
            className="grid size-11 place-items-center rounded-xl border border-line bg-surface-2/70 text-foreground/80 transition-colors duration-300 can-hover:group-hover/icon:border-foreground/30 can-hover:group-hover/icon:text-foreground"
          >
            {item.icon}
          </span>
          <span className="sr-only">{item.name}</span>
        </motion.li>
      ))}
    </motion.ul>
  );
}

// =============================================================================
